import { Component, OnInit } from '@angular/core';
import * as Feather from 'feather-icons';
import { ServerService } from '../services/server.service';
import { Router } from '@angular/router';
declare var iziToast:any;
import Swal from 'sweetalert2'	
// import {DomSanitizationService} from '@angular/platform-browser';

// import { Pipe, PipeTransform } from '@angular/core';
// import { DomSanitizer } from '@angular/platform-browser';

// @Pipe({name: 'mySafe'})
// export class SafePipe implements PipeTransform {
//     constructor(private sanitizer: DomSanitizer) {
//     }

//     public transform(url) {
//         return this.sanitizer.bypassSecurityTrustResourceUrl(url);
//     }
// }
import { Pipe, PipeTransform } from '@angular/core';

import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {}
 
 public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default: throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}
 // static get parameters() {
 //    return [DomSanitizationService];
 //  }


@Component({
  selector: 'app-reseller-price-list',
  templateUrl: './reseller-price-list.component.html',
  styleUrls: ['./reseller-price-list.component.css']
})
export class ResellerPriceListComponent implements OnInit {
  //  static get parameters() {
  //   return [DomSanitizationService];
  // }
selectedtab;
reseller_product_details:any=[];
url="https://erp.cal4care.com/cms_new/images/product_img/";
cxpricelist:any=[];
HtekIPPhones:any=[];
headsets:any=[];
CXAPPLIANCE3CXSBC:any=[];
beronet:any=[];
intercomspasystem:any=[];
siptrunkslocal:any=[];
faxata3cx:any=[];
conferencephonewebmeeting:any=[];
hotelphones:any=[];
yealink:any=[];
snomipphones:any=[];
internationaldidprice:any=[];
pdfview;
pdfviews;
showingtab;
currency_symbol_datas:any=[];
currency_symbol_val:any=[];


 cloud_my_cloud:any=[];
  cloud_sg_call:any=[];;
   cloud_thb_clear:any=[];

   cloudheader:any=[];
   callheader:any=[];
   clearheader:any=[];
   totaldatas:any;

   cloud_my_cloud_details_stnd:any=[];
   cloud_my_cloud_details_prof:any=[];

   cloud_sg_call_details_stnd:any=[];
   cloud_sg_call_details_prof:any=[];

cloud_thb_clear_details_stnd:any=[];
cloud_thb_clear_details_prof:any=[];
  constructor(private router:Router,private serverService: ServerService) { 
 // this.sanitizer = sanitizer;    

  }

  ngOnInit(): void {
  	this.resellerproduct()
  }

ngAfterViewInit() {
    Feather.replace();
  }

  showactive(val){
    this.showingtab= val;
  }
  // photoURL(urls) {
  //   return this.sanitizer.bypassSecurityTrustUrl(urls);
  // }

// {"access_token":"OTA3IyMjOGRjMTBkYWRiMTFiN2M4Y2MxODI=","operation":"curlDatas","moduleType":"login","api_type":"web","element_data":{"action":"reseller_product","customer_id":"ODA="}}
resellerproduct(){
 Swal.fire('Please wait')
Swal.showLoading()
  let datas:any =new Object();
 let datasend:any = new Object();
    let access_token: any=localStorage.getItem('at');
    let customer_id: any=localStorage.getItem('en');
   
   
datas.action="reseller_product";
datas.customer_id = customer_id;




 datasend.access_token=access_token;
  datasend.operation="curlDatas";
  datasend.moduleType="login";
  datasend.api_type="web";
  datasend.element_data = datas;
      // this.serverService.sendServerpath(datasend).subscribe((response: any) => {
      this.serverService.sendServer(datasend).subscribe((response: any) => {
console.log(response)
        if(response.status=="true"){
          this.totaldatas= response;
    this.reseller_product_details = response.reseller_product_details;
    this.cloud_my_cloud=response.callacloud_shopping_title_details;
    this.cloud_sg_call=response.calncall_shopping_title_detail;
    this.cloud_thb_clear=response.callnclear_shopping_title_details;
   
 
 

for (var i = 0; i < response.callacloud_shopping_page_details.length; i++) {
  if(response.callacloud_shopping_page_details[i].data.model_type_id == "1"){
this.cloud_my_cloud_details_stnd.push(response.callacloud_shopping_page_details[i])
  }
  else if(response.callacloud_shopping_page_details[i].data.model_type_id == "2"){
this.cloud_my_cloud_details_prof.push(response.callacloud_shopping_page_details[i])

  }
}
for (var i = 0; i < response.calncall_shopping_page_details.length; i++) {
  if(response.calncall_shopping_page_details[i].data.model_type_id == "1"){
this.cloud_sg_call_details_stnd.push(response.calncall_shopping_page_details[i])
  }
  else if(response.calncall_shopping_page_details[i].data.model_type_id == "2"){
this.cloud_sg_call_details_prof.push(response.calncall_shopping_page_details[i])

  }
}
for (var i = 0; i < response.callnclear_shopping_page_details.length; i++) {
  if(response.callnclear_shopping_page_details[i].data.model_type_id == "1"){
 this.cloud_thb_clear_details_stnd.push(response.callnclear_shopping_page_details[i])
  }
   else if(response.callnclear_shopping_page_details[i].data.model_type_id == "2"){
 this.cloud_thb_clear_details_prof.push(response.callnclear_shopping_page_details[i])
  }
}

if(this.cloud_my_cloud.length != 0){
for (var i = 0; i < this.cloud_my_cloud.length; i++) {
  if(this.cloud_my_cloud[i].data.cart_setting_name == "product_edition"){
this.cloudheader.push(this.cloud_my_cloud[i])
  }
   if(this.cloud_my_cloud[i].data.cart_setting_name == "sim_calls"){
this.cloudheader.push(this.cloud_my_cloud[i])
    
  }
   if(this.cloud_my_cloud[i].data.cart_setting_name == "max_extension_allowed"){
this.cloudheader.push(this.cloud_my_cloud[i])
    
  }
   if(this.cloud_my_cloud[i].data.cart_setting_name == "minimum_contract_period"){
this.cloudheader.push(this.cloud_my_cloud[i])
    
  }
   if(this.cloud_my_cloud[i].data.cart_setting_name == "session_border_device_providerd"){
this.cloudheader.push(this.cloud_my_cloud[i])
    
  }
    if(this.cloud_my_cloud[i].data.cart_setting_name == "setup_charge"){
this.cloudheader.push(this.cloud_my_cloud[i])
    
  }
    if(this.cloud_my_cloud[i].data.cart_setting_name == "setup_charge_yen"){
this.cloudheader.push(this.cloud_my_cloud[i])
    
  }
  if(this.cloud_my_cloud[i].data.cart_setting_name == "monthly_subscription_dedicated"){
this.cloudheader.push(this.cloud_my_cloud[i])
    
  }
}
}
console.log(this.callheader)

if(this.cloud_sg_call.length != 0){
  for (var i = 0; i < this.cloud_sg_call.length; i++) {
  if(this.cloud_sg_call[i].data.cart_setting_name == "product_edition"){
this.callheader.push(this.cloud_sg_call[i])
  }
   if(this.cloud_sg_call[i].data.cart_setting_name == "sim_calls"){
this.callheader.push(this.cloud_sg_call[i])
    
  }
   if(this.cloud_sg_call[i].data.cart_setting_name == "max_extension_allowed"){
this.callheader.push(this.cloud_sg_call[i])
    
  }
   if(this.cloud_sg_call[i].data.cart_setting_name == "minimum_contract_period"){
this.callheader.push(this.cloud_sg_call[i])
    
  }
   if(this.cloud_sg_call[i].data.cart_setting_name == "session_border_device_providerd"){
this.callheader.push(this.cloud_sg_call[i])
    
  }
    if(this.cloud_sg_call[i].data.cart_setting_name == "setup_charge"){
this.callheader.push(this.cloud_sg_call[i])
    
  }
    if(this.cloud_sg_call[i].data.cart_setting_name == "setup_charge_yen"){
this.callheader.push(this.cloud_sg_call[i])
    
  }
  if(this.cloud_sg_call[i].data.cart_setting_name == "monthly_subscription_dedicated"){
this.callheader.push(this.cloud_sg_call[i])
    
  }
}
}

console.log(this.callheader)
if(this.cloud_thb_clear.length != 0){
  for (var i = 0; i < this.cloud_thb_clear.length; i++) {
  if(this.cloud_thb_clear[i].data.cart_setting_name == "product_edition"){
this.clearheader.push(this.cloud_thb_clear[i])
  }
   if(this.cloud_thb_clear[i].data.cart_setting_name == "sim_calls"){
this.clearheader.push(this.cloud_thb_clear[i])
    
  }
   if(this.cloud_thb_clear[i].data.cart_setting_name == "max_extension_allowed"){
this.clearheader.push(this.cloud_thb_clear[i])
    
  }
   if(this.cloud_thb_clear[i].data.cart_setting_name == "minimum_contract_period"){
this.clearheader.push(this.cloud_thb_clear[i])
    
  }
   if(this.cloud_thb_clear[i].data.cart_setting_name == "session_border_device_providerd"){
this.clearheader.push(this.cloud_thb_clear[i])
    
  }
    if(this.cloud_thb_clear[i].data.cart_setting_name == "setup_charge"){
this.clearheader.push(this.cloud_thb_clear[i])
    
  }
    if(this.cloud_thb_clear[i].data.cart_setting_name == "setup_charge_yen"){
this.clearheader.push(this.cloud_thb_clear[i])
    
  }
  if(this.cloud_thb_clear[i].data.cart_setting_name == "monthly_subscription_dedicated"){
this.clearheader.push(this.cloud_thb_clear[i])
    
  }
}
}

// console.log(this.cloudheader)
// console.log(this.clearheader)

  // 
    var currency_symbol_dat = response.currency_symbol_datass;
var currency_symbol_val = response.currency_data;
const mappeds = Object.keys(currency_symbol_val).map(key => ({symbol: key, val: currency_symbol_val[key]}));

const mapped = Object.keys(currency_symbol_dat).map(key => ({name: key, symbol: currency_symbol_dat[key]}));
    this.currency_symbol_datas = mapped;
    this.currency_symbol_val = mappeds;

// console.log(this.currency_symbol_val);

// console.log(this.currency_symbol_datas.length);
    // console.log(this.reseller_product_details)
    for (var i = 0; i < this.reseller_product_details.length; i++) {
     if(this.reseller_product_details[i].data.product_category_id == "78"){
this.cxpricelist.push(this.reseller_product_details[i])

     }
      if(this.reseller_product_details[i].data.product_category_id == "2"){

this.HtekIPPhones.push(this.reseller_product_details[i])
     }
      if(this.reseller_product_details[i].data.product_category_id == "75"){
        this.headsets.push(this.reseller_product_details[i])

     }
       if(this.reseller_product_details[i].data.product_category_id == "73"){
        this.CXAPPLIANCE3CXSBC.push(this.reseller_product_details[i])

     }
       if(this.reseller_product_details[i].data.product_category_id == "3"){
        this.beronet.push(this.reseller_product_details[i])
     }
  if(this.reseller_product_details[i].data.product_category_id == "76"){
        this.intercomspasystem.push(this.reseller_product_details[i])
     }
      if(this.reseller_product_details[i].data.product_category_id == "71"){
        this.siptrunkslocal.push(this.reseller_product_details[i])
     }
 if(this.reseller_product_details[i].data.product_category_id == "79"){
        this.faxata3cx.push(this.reseller_product_details[i])
     }
      if(this.reseller_product_details[i].data.product_category_id == "80"){
        this.conferencephonewebmeeting.push(this.reseller_product_details[i])
     }
      if(this.reseller_product_details[i].data.product_category_id == "81"){
        this.hotelphones.push(this.reseller_product_details[i])
     }
      if(this.reseller_product_details[i].data.product_category_id == "1"){
        this.yealink.push(this.reseller_product_details[i])
     }
      if(this.reseller_product_details[i].data.product_category_id == "82"){
        this.snomipphones.push(this.reseller_product_details[i])
     }
      if(this.reseller_product_details[i].data.product_category_id == "83"){
        this.internationaldidprice.push(this.reseller_product_details[i])
     }
     
  

    }

      for (var i = 0; i < this.HtekIPPhones.length; i++) {
      
this.HtekIPPhones[i].data.rate_1 = this.HtekIPPhones[i].data.rate_1.replace("%","");
this.HtekIPPhones[i].data.rate_2 = this.HtekIPPhones[i].data.rate_2.replace("%","");;
this.HtekIPPhones[i].data.rate_3 = this.HtekIPPhones[i].data.rate_3.replace("%","");
this.HtekIPPhones[i].data.rate_4 = this.HtekIPPhones[i].data.rate_4.replace("%","");
       // this.pdfview ='https://docs.google.com/gview?url='+urling+'&embedded=true';
        

     }


       for (var i = 0; i < this.cxpricelist.length; i++) {
       var urling  = this.url+this.cxpricelist[0].data.product_img_1;

       this.pdfview ='https://docs.google.com/gview?url='+urling+'&embedded=true';
        
// var sendurl ='https://erp.cal4care.com/cms_old/loginProcess_old_conv.php?Aghwj=M'+cust_id+'=&bmVrb3Q='+this.datass+'';
     }


       for (var i = 0; i < this.internationaldidprice.length; i++) {
       var urlings  = this.url+this.internationaldidprice[0].data.product_img_1;

       this.pdfviews ='https://docs.google.com/gview?url='+urlings+'&embedded=true';
        
// var sendurl ='https://erp.cal4care.com/cms_old/loginProcess_old_conv.php?Aghwj=M'+cust_id+'=&bmVrb3Q='+this.datass+'';
     }
     // console.log(this.pdfview)
    console.log("cxprice",this.cxpricelist)
    console.log("HtekIPPhones",this.HtekIPPhones)
    console.log("headphone",this.headsets)
    console.log("CXAPPLIANCE3CXSBC",this.CXAPPLIANCE3CXSBC)
    console.log("beronet",this.beronet)
    console.log("intercomspasystem",this.intercomspasystem)
    console.log("siptrunkslocal",this.siptrunkslocal)
    console.log("faxata3cx",this.faxata3cx)
    console.log("conferencephonewebmeeting",this.conferencephonewebmeeting)
    console.log("hotelphones",this.hotelphones)
    console.log("yealink",this.yealink)
    console.log("snomipphones",this.snomipphones)
    console.log("internationaldidprice",this.internationaldidprice)
    
      //   iziToast.success({
      //     message: "Reseller ID changed",
      //     position: 'topRight'
      // });
         // this.getcart()
         Swal.close()
          }
        else{
         Swal.close()
          
  // iziToast.error({
  //         message: "Please try again later",
  //         position: 'topRight'
  //     });
 
      }

      
      }, 
      (error)=>{
          console.log(error);
      });

}

  // photoURL(img) {
  //   var imgval ='"https://erp.cal4care.com/cms_new/images/product_img"+"'imh'"'
  //   return this.sanitizer.bypassSecurityTrustUrl('https://erp.cal4care.com/cms_new/images/product_img/+img');
  // }

}
